
/* eslint-disable */
import CloudFun, { Condition, defineComponent, Operator, ref, onMounted, reactive } from '@cloudfun/core'
import Grid, { GridOptions } from '@/cloudfun/components/Grid.vue'
import { VxeFormProps } from 'vxe-table'
import SelectBox, { SelectBoxOptions } from '@/cloudfun/components/SelectBox.vue'
import FileUploader from "@/cloudfun/components/FileUploader.vue";
import QuestionTable from "./QuestionTable.vue";
import { VueUploadItem } from "vue-upload-component";

export default defineComponent({
  components: {
    Grid,
    QuestionTable,
  },
  setup () {
    const model = CloudFun.current?.model
    const grid = ref<any>({});
    const qnrGrid = ref<any>({});
    var printColumns = [
      { field: 'Name' },
      { field: 'Description' }
    ]

    const gridOptions: GridOptions = {
      stripe: false,
      title: '問卷',
      toolbarConfig: {
        custom: true,
        refresh: true
      },
      multiselect: false,      
      printConfig: { sheetName: '問卷清單', columns: printColumns, modes: ['current', 'selected', 'all'] },
      exportConfig: { filename: '問卷清單', type: 'csv', types: ['html', 'csv'], mode: 'all', modes: ['current', 'selected', 'all'], columns: printColumns },
      columns: [{
        field: 'Title',
        title: '標題',
        showHeaderOverflow: true,
        showOverflow: true,
        sortable: true,
        treeNode: false,
        editRender: { name: '$input', immediate: true, attrs: { type: 'text' } },
        filters: [{ checked: false, label: '包含' }],
        slots: { filter: 'filter-name' }
      },
      { field: 'Number', title: '編號', showHeaderOverflow: true, showOverflow: true, sortable: true },
      { field: 'Published', title: '已發布', showHeaderOverflow: true, showOverflow: true, sortable: true, formatter: ({ cellValue }) => cellValue ? '是' : '否', align: 'center' },
      {
        title: '問題管理',
        width: '100',
        slots: { default: "question" }, align: 'center' 
      },
      ],
      promises: {
        query: model ? (params) => {
          // if (params?.sortings?.length === 0) {
          //   params.sortings.push({ column: 'Ordinal', order: 0 }, { column: 'CreatedTime', order: 1 });
          // }
          // if (params.condition) params.condition.and('ParentId', Operator.IsNull)
          // else params.condition = new Condition('ParentId', Operator.IsNull)
          return model.dispatch('qnr/query', params)
        } : undefined,
        queryAll: model ? () => model.dispatch('qnr/query') : undefined,
        save: model ? (params) => model.dispatch('qnr/save', params) : undefined
      },
      modalConfig: { width: "50%", height: "380", showFooter: true },
      // treeConfig: { children: 'Children' }
    }

    const formOptions: VxeFormProps = {
      titleWidth: 80,
      titleAlign: 'right',
      items: [
        {
          field: 'Title',
          title: '名稱',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '請輸入文字', clearable: true }, attrs: { type: 'text' } }
        },
        {
          field: 'Number',
          title: '編號',
          span: 12,
          itemRender: { name: '$input', props: { placeholder: '由系統自動產生', readonly: true }, attrs: { type: 'text' } }
        },
        {
          field: 'Published',
          title: '已發布',
          span: 12,
          titleWidth: 80,
          itemRender: { name: '$select', options: [{ value: false, label: '否' }, { value: true, label: '是' }] }
        },
        { field: 'Introduction', title: '說明', span: 24, itemRender: { name: '$textarea', props: { autosize: { minRows: 2, maxRows: 4 }, placeholder: '請輸入文字' } } },
        { field: 'Remark', title: '備註', span: 24, itemRender: { name: '$textarea', props: { autosize: { minRows: 2, maxRows: 4 }, placeholder: '請輸入文字' } } },
        // {
        //   span: 24,
        //   titleWidth: 80,
        //   slots: { default: "column-question" }
        // },
      ],
      rules: {
        Name: [{ required: true }],
      }
    }

    const questionForm = ref<any>();

    const qnrTable = reactive({
      gridOptions: {
        stripe: false,
        title: '問題',
        toolbarConfig: {
          custom: true,
          refresh: true
        },
        canUpdate: false,
        canDelete: false,
        canRead:false,
        pagerConfig:{
          layouts: [
            "PrevPage",
            "Jump",
            "PageCount",
            "NextPage",
          ],
        },
        multiselect: false,
        printConfig: { sheetName: '問題清單', columns: printColumns, modes: ['current', 'selected', 'all'] },
        exportConfig: { filename: '問題清單', type: 'csv', types: ['html', 'csv'], mode: 'all', modes: ['current', 'selected', 'all'], columns: printColumns },
        columns: [{
          field: 'Title',
          title: '標題',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        { field: 'Ordinal', title: '排序', showHeaderOverflow: true, showOverflow: true, sortable: true },
        {
          field: "operate",
          title: "操作",
          align: "center",
          width: 150,
          slots: { default: "operate" }
        }
        ],
        promises: {
          query: model ? (params) => {
            if (params?.sortings?.length === 0) {
              params.sortings.push({ column: 'Ordinal', order: 0 }, { column: 'CreatedTime', order: 1 });
            }
            // if (params.condition) params.condition.and('ParentId', Operator.IsNull)
            // else params.condition = new Condition('ParentId', Operator.IsNull)
            return model.dispatch('question/query', params)
          } : undefined,
          queryAll: model ? () => model.dispatch('question/query') : undefined,
          save: model ? (params) => model.dispatch('question/save', params) : undefined
        },
        modalConfig: { width: "50%", height: "500", showFooter: true },
      } as GridOptions,
      addNewRow: (row: any, callback: any) => {
        row.Ordinal = 0;
        callback();
      },
      formOptions: {
        titleWidth: 80,
        titleAlign: 'right',
        items: [
          {
            field: 'Title',
            title: '名稱',
            span: 12,
            itemRender: { name: '$input', props: { placeholder: '請輸入文字', clearable: true }, attrs: { type: 'text' } }
          },          
          {
            field: 'Ordinal',
            title: '排序',
            span: 12,
            itemRender: { name: '$input', props: { type: 'number', placeholder: '請輸入數字' }, }
          },
        ],
        rules: {
          Title: [{ required: true }],
        }
      } as VxeFormProps,
      onGridEdit: async(row: any, callback: any) => {
        const entity = row.Id ? await model?.dispatch("question/find", row.Id) : undefined;
        if (entity) Object.assign(row, entity);        
        callback();
      },
      reset: (row: any) => {
        qnrGrid?.value.reset(row);
      },     
      submit: (row: any) => {      
        if(!row.Id) {
          console.log('insert', row)
          model?.dispatch("question/insert", row).then((data: any) =>{
            if(data && data.Id) {
              qnrGrid?.value.refresh();
              qnrGrid.value.isModalPopup = false;
              qnrGrid.value.editingRow = null;
            }
          }).catch((failure: any) => {
            const content = failure.message;
            CloudFun.send("error", {
              subject: '新增失敗',
              content,
            });
          });
        }        
      },
      remove: (row: any, callback: any) => {
        if(confirm("確定要刪除此筆資料嗎?")) {
          console.log(row);
          // model?.dispatch("question/delete", row.Id).then(() =>{
          //   console.log('ok')
          //   qnrGrid?.value.refresh();
          // }).catch((failure: any) => {
          //   const content = failure.message;
          //   CloudFun.send("error", {
          //     subject: '刪除失敗',
          //     content,
          //   });
          // });
        }
      }
    })

    const questionGrid = ref<any>()
    const questionModal = reactive({
      visible: false,
      selectedRow: {} as any,
      gridOptions: {
        promises: {
          query: model ? (params) => {
            console.log(questionModal.selectedRow.Id);
            params.condition = new Condition()
              .and("QnrId", Operator.Equal, questionModal.selectedRow.Id.toString())
              .and(params.condition!);
            if (!params.sortings || params.sortings?.length === 0)
              params.sortings = [{ column: "Ordinal", order: 0 }, { column: 'CreatedTime', order: 1 }];
            return model.dispatch("question/query", params);
          } : undefined,
          queryAll: model ? () => model.dispatch('question/query') : undefined,
          save: model ? (params) => model.dispatch('question/save', params) : undefined
        }
      } as GridOptions,
      show(row: any) {
        questionModal.visible = true;
        console.log(row)
        questionModal.selectedRow = row;
        if (questionGrid.value) questionGrid.value.refresh();
      }
    })

    const changeUser = (data: any, name: string) => {
      if (data && name) data.Name = name;
    };

    const headers = {
      Authorization: `Basic ${model?.getCertificate(0)}`
    };

   
    return {
      grid,
      gridOptions,
      formOptions,
      headers,
      changeUser,
      qnrTable,
      qnrGrid,
      questionForm,
      questionModal,
      questionGrid,
    }
  },
  methods: {
    hideBatchDropDown () {
      cash('#batch-dropdown').dropdown('hide')
    },
    async uploaderFilter (current: VueUploadItem, original: VueUploadItem, prevent: any) {
      if (!current || !current.name) return prevent();
      if (!/\.(png|gif|jpg|jpeg)$/i.test(current.name)) {
        alert("未支援此種圖片格式");
        return prevent();
      }
    },
    async onGridEdit(row: any, callback: any) {
      const entity = row.Id
        ? await this.$model.dispatch("qnr/find", row.Id)
        : undefined;
      if (entity) {
        if (entity.Keywords && entity.Keywords.length) {
          entity.KeywordIds = entity.Keywords.map((e: any) => e.KeywordId);
        } else {
          entity.KeywordIds = [];
        }
        Object.assign(row, entity);
      }
      callback();
    }
  }
})
